export default "__VITE_ASSET__fd7c5c2b__"